<template>
  <ul class="dropdown-menu">
    <slot :selectedOptions="selectedOptions" :id="id"></slot>
  </ul>
</template>
<script>
export default {
  name: "bc-multi-dropdown-option-slot",
  props: {
    id: {
      type: String,
      default: null,
    },
    selectedOptions: {
      type: Array,
      default: null,
    },
  },
  render() {
    return this.$slots.default;
  },
};
</script>